import styled from 'styled-components'
import { Image as BoltImage } from '@sainsburys-tech/bolt'

const AttributeSelectorWrapper = styled.button`
  display: flex;
  background-color: ${props => props.theme.color.monochrome.lighter};
  margin-bottom: 10px;
  align-items: stretch;
  width: 100%;
  border: none;
  padding: 0;
  font: inherit;
`
const ImageWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 76px;
  flex-shrink: 0;
`
const TextWrapper = styled.span`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  padding-left: 10px;
  flex-basis: auto;
  flex-shrink: 0;
  max-width: calc(100% - 100px);
`
const AttributeSelectorHeading = styled.span`
  font-weight: ${props => props.theme.font.weight.bold};
`

const IconWrapper = styled.span`
  flex-basis: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 10px;
`

const Image = styled(BoltImage)`
  display: flex;
  height: 76px;
  width: 100%;
`

export { AttributeSelectorWrapper, ImageWrapper, TextWrapper, AttributeSelectorHeading, IconWrapper, Image }
